import * as Api from '@ViewModels';
import { ComposeEmailViewModel } from '../../viewmodels/AppViewModels';

/**
 * Gets unsubscribe reason
 * @source Original location: UiUtils.ts.backup line 2263
 */
export const getUnsubscribeReason = (metadata: Api.IUnsubscribeMetadata): string => {
	if (!metadata?.reason) {
		return '';
	}

	switch (metadata.reason) {
		case Api.UnsubscribeReason.ByUser:
			return `by ${metadata?.actor?.name || 'Unknown'}`;
		case Api.UnsubscribeReason.ByAI:
			return 'by Levitate AI';
		case Api.UnsubscribeReason.ByCSVParser:
			return 'by a lead parser integration';
		case Api.UnsubscribeReason.ByIntegration:
			return 'due to integration settings';
		case Api.UnsubscribeReason.ByRecipient:
			return 'due to their "Unsubscribe me" response';
		case Api.UnsubscribeReason.Unknown:
		default:
			return '';
	}
};

/**
 * Checks if sender is not current user
 * @source Original location: UiUtils.ts.backup line 2777
 */
export const senderIsNotCurrentUser = (emailMessage: Api.EmailMessageViewModel<any, any, any>) => {
	const { isSendFromOption } = emailMessage;

	if (!isSendFromOption) {
		return false;
	}
	return isSendFromOption(Api.SendEmailFrom.ContactOwner) || isSendFromOption(Api.SendEmailFrom.SelectedUser);
};

/**
 * Updates contact filter send from
 * @source Original location: UiUtils.ts.backup line 2789
 */
export const updateContactFilterSendFrom = ({
	emailComposer,
	newSendFrom,
	newSendFromUserId,
	partialCurrentUser,
	ownershipFilter,
}: {
	emailComposer: ComposeEmailViewModel;
	newSendFrom: Api.ISendEmailFrom;
	newSendFromUserId: string | null;
	partialCurrentUser: Api.IUser;
	ownershipFilter: Api.IOwnershipFilter;
}) => {
	let sendFromUser;
	if (newSendFrom === Api.SendEmailFrom.CurrentUser) {
		sendFromUser = partialCurrentUser;
	} else if (newSendFromUserId) {
		sendFromUser = { id: newSendFromUserId };
	} else {
		sendFromUser = null;
	}

	const userId = newSendFromUserId;
	const emailOptions = emailComposer.emailMessage.options;
	if (userId) {
		const fromCurrentUser = partialCurrentUser.id === userId;
		emailOptions.sendEmailFrom = newSendFrom;
		emailOptions.sendEmailFromUser = sendFromUser;
		emailOptions.sendEmailFromUserId = fromCurrentUser ? undefined : userId;

		emailComposer.emailMessage.contactsFilterRequest.ownershipFilter = ownershipFilter ?? {
			criteria: {
				property: Api.ContactFilterCriteriaProperty.OwnedBy,
				value: userId,
			},
		};
	} else {
		emailOptions.sendEmailFrom = Api.SendEmailFrom.ContactOwner;
		emailOptions.sendEmailFromUser = undefined;
		emailOptions.sendEmailFromUserId = undefined;
		emailComposer.emailMessage.contactsFilterRequest.ownershipFilter = ownershipFilter;
	}

	emailComposer.updateApproximationForFilter();
	emailComposer.getNextBatchOfRecipients();
};
